import { useTopProgramsYesterday } from "../../hooks/useTopProgramsYesterday";
import { formatNumber } from "../../utils/formatNumber";
import "./OverviewCards.css";

// Yesterday's three strongest programmes on this channel, by average active TV.

function hhmm(minute) {
  const h = String(Math.floor(minute / 60)).padStart(2, "0");
  const m = String(minute % 60).padStart(2, "0");
  return `${h}:${m}`;
}

export default function OverviewTopProgramsCard({ channelId, rawVideo }) {
  const { programs, loading } = useTopProgramsYesterday(channelId, rawVideo);

  return (
    <div className="overview-card card-indigo ov-list-card">
      <div className="card-icon">
        <i className="fa-solid fa-clapperboard" />
      </div>

      {/* No channel logo here: every row is this same channel, so the mark
          would repeat three times and separate nothing. */}
      <ol className="ov-list">
        {programs.map((p, i) => (
          <li key={p.id || i} className="ov-list-item">
            <span className="ov-list-rank">{i + 1}</span>
            <span className="ov-list-name" title={p.name}>
              {p.name}
              <span className="ov-list-sub">{hhmm(p.start)}</span>
            </span>
            <span className="ov-list-value">{formatNumber(p.value)}</span>
          </li>
        ))}

        {loading && programs.length === 0 && <li className="ov-list-empty">…</li>}
        {!loading && programs.length === 0 && (
          <li className="ov-list-empty">No programme data for yesterday.</li>
        )}
      </ol>

      <div className="card-title">yesterday's top 4 programmes</div>
    </div>
  );
}
